import { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'subtle' | 'ghost' | 'plain';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  fullWidth?: boolean;
}

const VARIANTS: Record<Variant, string> = {
  primary: 'bg-hs-primary text-hs-on-primary hover:bg-hs-primary-hover',
  subtle: 'bg-hs-surface-alt text-hs-text hover:brightness-95',
  ghost: 'bg-transparent text-hs-text border border-hs-border hover:bg-hs-surface-alt',
  plain: 'bg-transparent text-hs-primary hover:underline',
};

export function Button({
  variant = 'primary',
  loading = false,
  fullWidth = false,
  disabled,
  className = '',
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      {...rest}
      disabled={disabled || loading}
      className={[
        'inline-flex items-center justify-center gap-2 h-9 px-4 rounded-hs-sm',
        'text-[13.5px] font-semibold transition-colors',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-hs-primary focus-visible:ring-offset-2',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        fullWidth ? 'w-full' : '',
        VARIANTS[variant],
        className,
      ].join(' ')}
    >
      {loading && (
        <svg className="animate-spin" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="3" opacity="0.25" />
          <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
        </svg>
      )}
      {children}
    </button>
  );
}
